import { render, staticRenderFns } from "./AddRate.vue?vue&type=template&id=97f819cc&"
import script from "./AddRate.vue?vue&type=script&lang=js&"
export * from "./AddRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports